<template>
  <header class="header">
    <div class="table-actions-wrap">
      <div class="left-aligned-wrap">
        <woot-sidemenu-icon />
        <div class="box-select-kanban">
          <kanban-context
            v-if="kanbanListActive.length > 0"
            :kanbanSelect="kanbanSelectItem"
            @toggle-kanban="toggleKanbanModal"
            :countKanban="kanbanListActive.length"
          />
        </div>
        <div
          v-if="showStatusFilter"
          class="advanced-filter-wrap"
          ref="filterWrap"
        >
          <div class="filter-toggle-wrap">
            <div style="position: relative;">
              <woot-button
                v-tooltip="$t('TICKET.FILTER.TITLE')"
                icon="filter"
                variant="smooth"
                color-scheme="secondary"
                size="small"
                :class="{ 'filter-btn--active': activeAdvancedFilterCount > 0 }"
                @click.stop="toggleFilterPanel"
              />
              <span v-if="activeAdvancedFilterCount > 0" class="filter-badge">{{
                activeAdvancedFilterCount
              }}</span>
            </div>
            <woot-button
              v-tooltip="'Selecionar Tickets'"
              variant="smooth"
              color-scheme="secondary"
              size="small"
              @click="$emit('enter-selection-mode')"
            >
              <i class="ion-ios-checkmark-outline"></i>
            </woot-button>
          </div>
          <ticket-filter-panel
            v-show="showFilterPanel"
            ref="filterPanel"
            :status-options="statusOptions"
            :agent-options="agentOptions"
            :priority-options="priorityOptions"
            :applied-status="statusFilter"
            :applied-search-query="searchQuery"
            :applied-date-field="dateField"
            :applied-start-date="startDate"
            :applied-end-date="endDate"
            :applied-agent-ids="agentFilter"
            :applied-priority="priorityFilter"
            :applied-label-ids="labelFilter"
            :hide-agent-filter="hideAgentFilter"
            @filter-apply="applyAdvancedFilters"
            @clear="clearAdvancedFilters"
          />
        </div>
      </div>
    </div>
    <div class="right-section">
      <div class="card-data-tickets" v-if="kanbanListActive.length > 0">
        <p class="total">{{ meta.total_tickets }}&nbsp;</p>
        <p class="tickets" v-if="!isFunnelSale">{{ ticketsLabel }}</p>
        <p class="tickets" v-if="isFunnelSale">{{ ticketsLabel }}:&nbsp;</p>
        <p class="money" v-if="isFunnelSale">
          {{ formatCurrency(meta.total_sales_value) }}
        </p>
      </div>
      <div class="header-buttons">
        <div
          v-if="kanbanListActive.length > 0"
          class="new-ticket-group"
          ref="bulkMenuWrap"
        >
          <div class="button-group">
            <woot-button
              color-scheme="primary"
              icon="add-circle"
              @click="toggleNewTicketModal"
            >
              {{ newTicketLabel }}
            </woot-button>
            <woot-button
              color-scheme="primary"
              icon="chevron-down"
              @click.stop="toggleBulkMenu"
            />
          </div>
          <div v-if="showBulkMenu" class="bulk-menu">
            <button class="bulk-menu-item" @click="openBulkImportModal">
              {{ $t('CRM_BULK_IMPORT.MENU_ACTION') }}
            </button>
          </div>
        </div>

        <woot-button
          v-if="showAddkanban"
          @click="$emit('redirect-kanban-page')"
          color-scheme="success"
          class-names="bg-primary"
          icon="settings"
        >
          {{ $t('CRM_MGMT.MANAGE_KANBAN_BUTTON') }}
        </woot-button>
      </div>
    </div>

    <modal-new-ticket
      v-if="showNewTicketModal"
      :show="showNewTicketModal"
      :show-contact-field="true"
      :preselected-kanban="kanbanSelectItem"
      @cancel="toggleNewTicketModal"
      @success="onTicketCreated"
    />

    <modal-bulk-import-tickets
      v-if="showBulkImportModal"
      :preselected-kanban="kanbanSelectItem"
      @cancel="toggleBulkImportModal"
      @success="onBulkImportSuccess"
    />

    <kanban-selector
      v-if="kanbanListActive.length > 0"
      :show-kanban-modal="showKanbanModal"
      @close-kanban-modal="toggleKanbanModal"
      @set-kanban="setKanban"
      :kanban-list="kanbanListActive"
      :kanban-select="kanbanSelectItem"
    />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import { canAccessCRM } from 'dashboard/helper/crmPermissionHelper';
import adminMixin from 'dashboard/mixins/isAdmin';
import KanbanContext from './KanbanContext.vue';
import KanbanSelector from './KanbanSelector.vue';
import ModalNewTicket from '../../conversation/contact/ModalNewTicket.vue';
import ModalBulkImportTickets from './ModalBulkImportTickets.vue';
import TicketFilterPanel from './TicketFilterPanel.vue';
import { formatCurrency } from '../../../../helper/formatCurrency';

export default {
  mixins: [adminMixin],
  components: {
    KanbanContext,
    KanbanSelector,
    ModalNewTicket,
    ModalBulkImportTickets,
    TicketFilterPanel,
  },
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
    initialKanbanId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      kanbanSelected: null,
      showKanbanModal: false,
      showNewTicketModal: false,
      showBulkImportModal: false,
      showBulkMenu: false,
      statusFilter: ['open'],
      showFilterPanel: false,
      searchQuery: '',
      dateField: 'created_at',
      startDate: '',
      endDate: '',
      agentFilter: [],
      priorityFilter: [],
      labelFilter: [],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      kanbanList: 'getKanbanfunnels',
      agentList: 'agents/getAgents',
      uiSettings: 'getUISettings',
    }),

    isFunnelSale() {
      return this.kanbanSelectItem?.enable_sales_funnel;
    },

    showStatusFilter() {
      const kanban = this.kanbanSelectItem;
      return kanban && kanban.type_opportunity;
    },

    isBusinessOpportunity() {
      const kanban = this.kanbanSelectItem;
      return (
        kanban &&
        (kanban.type_opportunity === 'business' ||
          kanban.type_opportunity === 'both')
      );
    },

    statusOptions() {
      if (this.isBusinessOpportunity) {
        return [
          { label: this.$t('TICKET.STATUS.OPEN'), value: 'open' },
          { label: this.$t('TICKET.STATUS.GAIN'), value: 'gain' },
          { label: this.$t('TICKET.STATUS.LOSE'), value: 'lose' },
          { label: this.$t('TICKET.STATUS.DELETED'), value: 'deleted' },
        ];
      }
      return [
        { label: this.$t('TICKET.STATUS.OPEN'), value: 'open' },
        { label: this.$t('TICKET.STATUS.DELETED'), value: 'deleted' },
      ];
    },

    ticketsLabel() {
      return this.isBusinessOpportunity
        ? this.$t('TICKET.BUSINESS_TITLE')
        : this.$t('TICKET.TITLE');
    },

    priorityOptions() {
      return [
        {
          label: this.$t('TICKET.FORM.PRIORITY.OPTIONS.CRITICAL'),
          value: 'critical',
        },
        { label: this.$t('TICKET.FORM.PRIORITY.OPTIONS.HIGH'), value: 'high' },
        {
          label: this.$t('TICKET.FORM.PRIORITY.OPTIONS.MEDIUM'),
          value: 'medium',
        },
        { label: this.$t('TICKET.FORM.PRIORITY.OPTIONS.LOW'), value: 'low' },
      ];
    },

    agentOptions() {
      return [
        { id: 'unassigned', name: this.$t('TICKET.FILTER.NO_AGENT') },
        ...this.agentList,
      ];
    },

    activeAdvancedFilterCount() {
      let count = 0;
      if (this.searchQuery) count++;
      if (this.startDate || this.endDate) count++;
      if (this.labelFilter.length > 0) count++;
      if (this.agentFilter.length > 0) count++;
      if (this.priorityFilter.length > 0) count++;
      if (!(this.statusFilter.length === 1 && this.statusFilter[0] === 'open'))
        count++;
      return count;
    },

    showAddkanban() {
      if (this.isAdmin) {
        return true;
      }
      return this.currentUser?.permissions?.crm_settings;
    },

    hideAgentFilter() {
      if (this.isAdmin) return false;
      return !!this.kanbanSelectItem?.restrict_own_tickets;
    },

    kanbanSelectItem() {
      if (!this.kanbanSelected) return null;
      return this.kanbanListActive.find(
        kanban => kanban.id == this.kanbanSelected
      );
    },

    kanbanListActive() {
      const listActive = this.kanbanList.filter(kanban => kanban.active);
      const isAdminOrSuperAdmin =
        this.currentUser?.type === 'SuperAdmin' ||
        this.currentUser?.type_role === 'administrator';
      const filtered = isAdminOrSuperAdmin
        ? listActive
        : listActive.filter(kanban =>
            kanban?.agents_ids?.includes(this.currentUser.id)
          );
      this.kanbanSelected =
        this.initialKanbanId || this.kanbanSelected || filtered[0]?.id || null;
      return filtered;
    },

    newTicketLabel() {
      if (!this.kanbanSelectItem) {
        return this.$t('TICKET.NEW_TICKET');
      }
      if (this.kanbanSelectItem.type_opportunity === 'both') {
        return this.$t('TICKET.NEW_BOTH');
      }
      const isBusinessOpportunity =
        this.kanbanSelectItem.type_opportunity === 'business';
      return isBusinessOpportunity
        ? this.$t('TICKET.NEW_BUSINESS')
        : this.$t('TICKET.NEW_TICKET');
    },
  },
  methods: {
    formatCurrency,

    emitKanbanSelected() {
      this.$emit('update-kanban-selected', this.kanbanSelected);
    },

    setKanban(id) {
      this.kanbanSelected = id;
      this.toggleKanbanModal();
    },

    persistKanbanPreference(kanbanId) {
      if (!kanbanId || !this.accountId) return;
      const savedKanbanIds = this.uiSettings?.lastSelectedKanbanIds || {};
      this.$store.dispatch('updateUISettings', {
        uiSettings: {
          lastSelectedKanbanIds: {
            ...savedKanbanIds,
            [this.accountId]: kanbanId,
          },
        },
      });
    },

    toggleKanbanModal() {
      this.showKanbanModal = !this.showKanbanModal;
    },

    toggleNewTicketModal() {
      this.showNewTicketModal = !this.showNewTicketModal;
    },

    toggleBulkMenu() {
      this.showBulkMenu = !this.showBulkMenu;
    },

    toggleBulkImportModal() {
      this.showBulkImportModal = !this.showBulkImportModal;
    },

    openBulkImportModal() {
      this.showBulkMenu = false;
      this.showBulkImportModal = true;
    },

    onBulkImportSuccess() {
      this.showBulkImportModal = false;
      this.$store.dispatch('labelsCrm/get');
      this.$emit('ticket-created');
    },

    onTicketCreated() {
      this.$emit('ticket-created');
    },

    toggleFilterPanel() {
      this.showFilterPanel = !this.showFilterPanel;
    },

    applyAdvancedFilters(filters = {}) {
      const {
        searchQuery,
        dateField,
        status,
        startDate,
        endDate,
        agentIds,
        priority,
        labelIds,
      } = filters;

      this.searchQuery = searchQuery || '';
      this.dateField = dateField || 'created_at';
      this.statusFilter = status && status.length > 0 ? status : ['open'];
      this.startDate = startDate || '';
      this.endDate = endDate || '';
      this.agentFilter = agentIds || [];
      this.priorityFilter = priority || [];
      this.labelFilter = labelIds || [];
      this.showFilterPanel = false;
      this.$emit('advanced-filters-changed', {
        searchQuery: this.searchQuery,
        dateField: this.dateField,
        status: this.statusFilter,
        startDate: this.startDate,
        endDate: this.endDate,
        agentIds: this.agentFilter,
        priority: this.priorityFilter,
        labelIds: this.labelFilter,
      });
    },

    clearAdvancedFilters() {
      this.statusFilter = ['open'];
      this.searchQuery = '';
      this.dateField = 'created_at';
      this.startDate = '';
      this.endDate = '';
      this.agentFilter = [];
      this.priorityFilter = [];
      this.labelFilter = [];
      this.showFilterPanel = false;
      this.$nextTick(() => {
        this.$refs.filterPanel?.syncPendingFromApplied();
      });
      this.$emit('advanced-filters-changed', {
        searchQuery: '',
        dateField: 'created_at',
        status: ['open'],
        startDate: '',
        endDate: '',
        agentIds: [],
        priority: [],
        labelIds: [],
      });
    },

    resetFiltersForKanbanChange() {
      this.statusFilter = ['open'];
      this.searchQuery = '';
      this.dateField = 'created_at';
      this.startDate = '';
      this.endDate = '';
      this.agentFilter = [];
      this.priorityFilter = [];
      this.labelFilter = [];
      this.showFilterPanel = false;
      this.$nextTick(() => {
        this.$refs.filterPanel?.syncPendingFromApplied();
      });
    },

    onClickOutside(e) {
      if (this.$refs.filterWrap && !this.$refs.filterWrap.contains(e.target)) {
        this.showFilterPanel = false;
      }
      if (
        this.$refs.bulkMenuWrap &&
        !this.$refs.bulkMenuWrap.contains(e.target)
      ) {
        this.showBulkMenu = false;
      }
    },

    openCreateAccountModal() {
      this.showKanbanModal = false;
    },
  },

  watch: {
    kanbanSelected(newVal, oldVal) {
      if (!newVal) return;

      if (oldVal != null && newVal !== oldVal) {
        this.resetFiltersForKanbanChange();
        this.persistKanbanPreference(newVal);
      }

      if (!oldVal || newVal !== oldVal) {
        this.emitKanbanSelected();
      }
    },
  },

  mounted() {
    document.addEventListener('click', this.onClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: var(--space-normal);
  overflow: visible;
}

.card-data-tickets {
  display: flex;
  align-items: center;
  .money,
  .total {
    font-weight: bold;
  }
  .money {
    color: #4caf50;
  }

  p {
    margin: 0;
  }
}

.table-actions-wrap {
  display: flex;
  gap: 3rem;
  flex: 1;
  min-height: 55px;
  padding: var(--space-small) var(--space-normal) var(--space-small)
    var(--space-normal);
  overflow: visible;
}
.custom-select {
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--color-border);
  font-size: var(--font-size-medium);
  margin: 0;
}

.box-select-kanban {
  display: flex;
  align-items: center;
  gap: 10px;
}
.box-select-kanban label {
  white-space: nowrap;
  font-size: 1.6rem;
  font-weight: bold;
}

.advanced-filter-wrap {
  margin-left: var(--space-normal);
  position: relative;
  overflow: visible;
}

.filter-toggle-wrap {
  position: relative;
  display: inline-flex;
  gap: 4px;
}

::v-deep .filter-btn--active {
  background-color: var(--w-75) !important;
  color: var(--w-600) !important;
}

.filter-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: var(--w-500);
  color: var(--white);
  border-radius: 9999px;
  font-size: 1rem;
  font-weight: bold;
  min-width: 1.6rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  line-height: 1;
}

.date-separator {
  color: var(--color-border);
  font-size: var(--font-size-small);
}

.date-input {
  flex: 1;
}

.status-select {
  margin: 0 !important;
  height: 3.4rem;
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--color-border);
  font-size: var(--font-size-small);
  background-color: var(--white);
  cursor: pointer;
  &:focus {
    outline: none;
    border-color: var(--w-500);
  }
}

.left-aligned-wrap {
  display: flex;
  align-items: center;
  gap: var(--space-small);
  max-width: 100%;
  min-width: var(--space-mega);
  overflow: visible;
}

.right-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--space-normal);
  flex-wrap: nowrap;
}

.header-buttons {
  display: flex;
  align-items: center;
  gap: var(--space-small);
}

.new-ticket-group {
  position: relative;
  display: flex;
  align-items: center;

  ::v-deep .button-group {
    display: flex;
    gap: 0;

    .button {
      border-radius: 0;
    }
    .button:first-child {
      border-top-left-radius: var(--border-radius-normal);
      border-bottom-left-radius: var(--border-radius-normal);
    }
    .button:last-child {
      border-top-right-radius: var(--border-radius-normal);
      border-bottom-right-radius: var(--border-radius-normal);
      border-left: 1px solid rgba(255, 255, 255, 0.25);
      padding-left: var(--space-small);
      padding-right: var(--space-small);
    }
  }
}

.bulk-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 100;
  background: var(--white);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-normal);
  box-shadow: var(--shadow-medium);
  min-width: 16rem;
  padding: var(--space-smaller);
}

.bulk-menu-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: var(--space-small) var(--space-normal);
  background: transparent;
  border-radius: var(--border-radius-small);
  font-size: var(--font-size-small);
  cursor: pointer;

  &:hover {
    background: var(--s-50);
  }
}
</style>
